var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThumbDownIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h16v16H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.066 10.6832c-.3664 0-.6912-.1416-.9744-.4248C.808 9.9752.666 9.6501.666 9.2832V7.9504c0-.0779.0056-.1613.0168-.2504.0112-.089.0336-.167.0672-.2336l2-4.6664c.0886-.2336.2523-.4253.4912-.5752.239-.1499.4861-.2248.7416-.2248h7.3504v8.6832l-3.7168 3.6336c-.2224.2219-.4696.3552-.7416.4-.2725.0443-.5253-.0059-.7584-.1504-.2336-.1333-.4002-.336-.5-.608-.1002-.272-.1114-.5637-.0336-.8752l.6168-2.4H2.066ZM9.9164 10.1V3.4H4.0332L2.066 7.9504v1.3328h5.9336l-.9168 3.6L9.9164 10.1ZM13.266 2c.3888 0 .7195.136.992.408.272.2725.408.6032.408.992v5.8832c0 .3888-.136.7195-.408.992-.2725.272-.6032.408-.992.408h-1.9328l-.0168-1.4h1.9496V3.4h-1.9496V2h1.9496Z",
    fill: "currentColor"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbDownIcon);
export default __webpack_public_path__ + "static/media/thumb-down-icon.7b18c939c03f74efc5f1ed5332cc157a.svg";
export { ForwardRef as ReactComponent };